import { get } from "lodash";
import Template from "../Template";
import View from "./View";

const SubscriptionDone = ({ currentStatus, project, onBack }) => {
  return (
    <Template
      progress={currentStatus.progress}
      HeaderComponent={null}
      View={<View />}
      contact={get(project, "contact")}
      project={project}
    />
  );
};
export default SubscriptionDone;
